// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aeefebf7","909":"5aeab44d","948":"8bc2e9c7"}[chunkId] + ".chunk.js";
};